import { lazy } from 'react';
import withLoadableComponent from './withLoadableComponent';
import retry from '../utils/webpack/chunkRetry';

export const LoadableCommissionEditPopup = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "commissioneditpopup" */
          '../CommissionEditPopup'
        )
    )
  )
);

export const LoadablePollEditPopup = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "polleditpopup" */
          '../PollEditPopup'
        )
    )
  )
);

export const LoadableAddToCollectionPopoverModal = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "actionbar" */
          '../ActionBar/_partials/AddToCollectionPopup/AddToCollectionModal'
        )
    )
  )
);

export const LoadableTierPopup = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "tierpopup" */
          '../Tier/TierPopup'
        )
    )
  )
);

export const LoadablePushNotificationsModal = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "pushnotifications" */
          '../PushNotificationsModal'
        )
    )
  )
);

export const LoadablePostProcurementPopup = withLoadableComponent(
  lazy(() =>
    retry(
      () =>
        import(
          /* webpackChunkName: "postprocurement" */
          '../DeviationPage/_partials/PostProcurementPopup'
        )
    )
  )
);
